import {loadScript, loadStylesheet} from "../main.source";

export function extraButtonsHelper($){



  $(document).on('change', '#btn_add_to_cart,#btn_info_display,#btn_link_display', handle_change);


  function handle_change(e) {

    var _t = $(this);

    if (_t.attr('id') === 'btn_add_to_cart') {

      $('.vplayer').each(function () {
        var _t2 = $(this);
        _t2.find('.dzsvg-add-to-cart').remove();
        if (_t.prop('checked')) {


          _t2.find('.timetext').eq(0).after('<div class="dzsvg-control dzsvg-add-to-cart"> <a href="#"> <i class="fa fa-shopping-cart"></i> </a> <div class="info-content "> Add to Cart </div> </div>')
        }

      })


    }


    if (_t.attr('id') === 'btn_info_display') {

      $('.vplayer').each(function () {
        var _t2 = $(this);
        _t2.find('.dzsvg-info').remove();
        if (_t.prop('checked')) {


          _t2.find('.timetext').eq(0).after('<a class="dzsvg-control dzsvg-info"> <i class="fa fa-info-circle"></i> <div class="info-content align-right" style="width: 300px;"> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </div> </a>')
        }

      })


    }

    if (_t.attr('id') === 'btn_link_display') {

      $('.vplayer').each(function () {
        var _t2 = $(this);
        _t2.find('.dzsvg-link').remove();
        if (_t.prop('checked')) {


          _t2.find('.timetext').eq(0).after('<a class="dzsvg-control dzsvg-link" href="index.html"> <i class="fa fa-link"></i> <div class="info-content " style=";"> Link to Home </div> </a>')
        }

      })


    }

  }
}


export function insertFacebookButtonAfter10000ms(){

  setTimeout(function () {
    jQuery('.insert-facebook-frame-here').html('<iframe src="//www.facebook.com/plugins/like.php?href=http%3A%2F%2Fcodecanyon.net%2Fitem%2Fvideo-gallery-wordpress-plugin-w-youtube-vimeo-%2F157782&amp;send=false&amp;layout=button_count&amp;width=450&amp;show_faces=true&amp;font&amp;colorscheme=light&amp;action=like&amp;height=21&amp;appId=151389461684900" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:125px; height:21px;" allowTransparency="true"></iframe>');
  }, 10000);
}


export function load_advancedScroller() {
  if (!window.dzs_loading_as) {
    window.dzs_loading_as = true;
  }
}

export function load_testimonialRotator() {
  if (!window.dzs_loading_tr) {
    window.dzs_loading_tr = true;


    loadScript("testimonialrotator/testimonialrotator.js");
    loadStylesheet("testimonialrotator/testimonialrotator.css");

  }
}